import { todayMxYmd } from "./dateMx";

/** Plantilla semanal por defecto: Lun–Vie 9–17. */
export function defaultWeeklyTemplate() {
  return [1, 2, 3, 4, 5].map((weekday) => ({
    weekday,
    ranges: [{ start: "09:00", end: "17:00" }],
  }));
}

export const WEEKDAY_LABELS = [
  "",
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
  "Domingo",
];

/**
 * Normaliza respuesta API (con o sin `versions`) a { blockedDates, versions }.
 */
export function normalizeScheduleClient(schedule) {
  if (!schedule) {
    const ef = todayMxYmd();
    return {
      blockedDates: [],
      versions: [{ effectiveFrom: ef, weekly: defaultWeeklyTemplate() }],
    };
  }
  const blocked = (schedule.blockedDates || [])
    .map((x) => String(x || "").trim().slice(0, 10))
    .filter((s) => /^\d{4}-\d{2}-\d{2}$/.test(s));
  if (schedule.versions?.length) {
    return {
      blockedDates: [...blocked],
      versions: [...schedule.versions].sort((a, b) =>
        (a.effectiveFrom || "").localeCompare(b.effectiveFrom || "")
      ),
    };
  }
  const ef = schedule.effectiveFrom || todayMxYmd();
  const weekly = schedule.weekly?.length ? schedule.weekly : defaultWeeklyTemplate();
  return {
    blockedDates: blocked,
    versions: [{ effectiveFrom: ef.slice(0, 10), weekly }],
  };
}

/** Estado por día 1–7: { enabled, ranges: [{start,end}] } */
export function weeklyToDayState(weekly) {
  const map = {};
  for (let d = 1; d <= 7; d += 1) {
    map[d] = { enabled: false, ranges: [{ start: "09:00", end: "17:00" }] };
  }
  for (const block of weekly || []) {
    const wd = block.weekday;
    if (wd < 1 || wd > 7) continue;
    map[wd] = {
      enabled: true,
      ranges: (block.ranges || [{ start: "09:00", end: "17:00" }]).map((r) => ({
        start: (r.start || "09:00").slice(0, 5),
        end: (r.end || "17:00").slice(0, 5),
      })),
    };
  }
  return map;
}

export function dayStateToWeekly(dayMap) {
  const weekly = [];
  for (let wd = 1; wd <= 7; wd += 1) {
    const day = dayMap[wd];
    if (!day?.enabled) continue;
    const ranges = (day.ranges || [])
      .filter((r) => r.start && r.end)
      .map((r) => ({
        start: r.start.slice(0, 5),
        end: r.end.slice(0, 5),
      }));
    if (ranges.length) weekly.push({ weekday: wd, ranges });
  }
  return weekly;
}
